angular.module("app")
.constant("ENV", {"api":"https://cloud.kwhotel.com/","images":"https://img.kwhotel.com/","begs":"https://be.guestsage.com/"});
